module.exports = __webpack_public_path__ + "img/Kroger Digital.8cbc22cf.png";